import * as React from "react";
import { Box, Flex, Text, Image, Container } from "@chakra-ui/react";
import { StaticImage } from "gatsby-plugin-image";

type TestimonialsProps = {
  title: string;
  testimonialsRepeater?: [
    {
      testimonialQuote: string;
      testimonialTitle: string;
      testimonialSubtitle: string;
    }
  ];
};

export const Testimonials = ({
  title,
  testimonialsRepeater,
}: TestimonialsProps) => {
  return (
    <Container
      maxW={{ base: "3xl", md: "7xl" }}
      py={36}
      px={{ base: "4", md: "0" }}
      fontSize={"4xl"}
      color="#09170d"
      fontFamily="'TradeGothic LT Bold'"
    >
      <Text
        pos={"relative"}
        lineHeight={"115%"}
        textTransform={"uppercase"}
        pb={16}
        textAlign={{ base: "center", md: "left" }}
      >
        {title}
      </Text>
      <Flex
        flexFlow={{ base: "column", md: "row" }}
        alignItems="flex-start"
        justifyContent="flex-start"
        gap="80px"
        fontSize={"md"}
        color="#768178"
        fontFamily="'TradeGothic LT'"
      >
        {testimonialsRepeater?.map((testimonial, index) => (
          <>
            <Box
              display="flex"
              flexDirection="column"
              pl={{ base: "8", md: "16" }}
              boxSizing="border-box"
              alignItems="flex-start"
              justifyContent="space-between"
              pos="relative"
              gap="16px"
            >
              <StaticImage
                src="../../../images/testimonials.svg"
                style={{
                  position: "absolute",
                  margin: "0",
                  top: "24px",
                  left: "0",
                  width: "86px",
                  height: "64px",
                }}
                alt={"testimonials"}
              />
              <Text
                position="relative"
                lineHeight="150%"
                display="flex"
                alignItems="center"
                zIndex="1"
              >
                {testimonial.testimonialQuote}
              </Text>
              <Flex
                alignSelf="stretch"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="flex-start"
                gap="8px"
                zIndex="2"
                fontSize="24px"
                color="#333b35"
              >
                <Text
                  alignSelf="stretch"
                  position="relative"
                  lineHeight="150%"
                  fontWeight={"700"}
                  textTransform="uppercase"
                  fontSize={{ base: "xl", md: "2xl" }}
                >
                  {testimonial.testimonialTitle}
                </Text>
                <Text
                  alignSelf="stretch"
                  position="relative"
                  fontSize="16px"
                  lineHeight="115%"
                  fontFamily="TradeGothic LT"
                  color="#817c25"
                >
                  {testimonial.testimonialSubtitle}
                </Text>
              </Flex>
            </Box>
          </>
        ))}
      </Flex>
    </Container>
  );
};
